module.exports = __webpack_public_path__ + "img/dashiji-2021.340c6d09.jpg";